// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"a3ec79f5","496":"f3573651","743":"1e4a472e","876":"78deb2a1"}[chunkId] + ".chunk.js";
};